import Component_CreatePortal_9f32bb11d548d428ac9198623d903eff from "../../../../content/examples/basic/create-portal/CreatePortal";
import Devtool_CreatePortal_9f32bb11d548d428ac9198623d903eff from "!!@devtool/loader!../../../../content/examples/basic/create-portal/CreatePortal";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_CreatePortal_9f32bb11d548d428ac9198623d903eff,
  Devtool_CreatePortal_9f32bb11d548d428ac9198623d903eff,
  DevTool,
  React
};